import { Component } from '@angular/core';
import { TabService } from './../../tab.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss'
})
export class ContentComponent {

  constructor(public  tabService: TabService, private router: Router, private activatedRoute: ActivatedRoute){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        let currentRoute = this.activatedRoute.root;

        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        const routeData = currentRoute.snapshot.data;
        let title = routeData['title']; // Use o valor de 'title' em data
        
          // Verifica se a rota tem o parâmetro 'id' e o concatena ao título
          const routeParams = currentRoute.snapshot.params;
        if (routeParams['id']) {
          title += ` ${routeParams['id']}`;
        }
        

        const url = event.urlAfterRedirects;
       // const title = this.getTitleFromUrl(url);
        this.tabService.addTab(title, url);
      }
    });
  }
  

  onTabChange(index: number) {
    console.log('aba: '+index)
    this.tabService.activeTabIndex = index;
    console.log('route', this.tabService.tabs[this.tabService.activeTabIndex].route)
    this.router.navigateByUrl(this.tabService.tabs[this.tabService.activeTabIndex].route);
  }

  closeTab(index: number) {
    this.tabService.closeTab(index);
  }

  getActiveTabId() {
    return this.tabService.tabs[this.tabService.activeTabIndex]?.id;
  }

  private getTitleFromUrl(url: string): string {
    // if (url.startsWith('/home')) return 'Home';
    // if (url.startsWith('/about')) return 'About';
    // if (url.startsWith('/contact')) return 'Contact';
    // if (url.startsWith('/ticket')) return '*Ticket ' + url.split('/')[2];
    return url.replaceAll('/', ' ').replaceAll('edit', '').trim();
  }

}


